import { useAtomCallback } from "jotai/utils";
import { useCallback } from "react";

import { TrackingEvents, sendLoggingEvents } from "../events";
import { useRoomEventListeners } from "../session/useRoomEventListeners";
import { participantCountAtom } from "../video-sdk";
import { useProviderDisconnectRoomCallback } from "./useProviderDisconnectRoomCallback";

export function useProviderRoomListeners() {
  const getParticipantCount = useAtomCallback(
    useCallback((get) => get(participantCountAtom), []),
  );

  const onPageUnload = () => {
    sendLoggingEvents(TrackingEvents.PROVIDER_TAB_CLOSE);
  };
  const disconnectRoom = useProviderDisconnectRoomCallback();
  const onRoomDisconnect = useCallback(
    () => {
      disconnectRoom();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  const onParticipantDisconnect = useCallback(
    function disconnectFromEmptyRoom() {
      if (getParticipantCount()) return;
      disconnectRoom();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useRoomEventListeners({
    onParticipantDisconnect,
    onRoomDisconnect,
    onPageUnload,
  });
}
